import find from 'lodash/find';
import map from 'lodash/map';

import { tableLocalStorageKeyByType } from 'components/CustomizeDisplayTable/constants';
import { EListsTypes } from 'types/listsTypes';
import { defaultOrdersTableSettings } from 'types/ordersTypes';
import { defaultProductsTableSettings } from 'types/productsTypes';

export const mergeArrays = (arrayTo: any[], arrayFrom: any[], key: string) =>
  map(arrayTo, (column) => ({ ...column, ...find(arrayFrom, { [key]: column[key] }) }));

const tablesSettings = {
  [EListsTypes.ProductsType]: defaultProductsTableSettings,
  [EListsTypes.OrdersType]: defaultOrdersTableSettings,
};

export const tableSettingsByList = (listType: EListsTypes) => {
  const localSettings = JSON.parse(localStorage.getItem(tableLocalStorageKeyByType[listType]) || '{}');
  const defaultSettingsByKey = tablesSettings[listType];

  return localSettings.length !== defaultSettingsByKey.length ? defaultSettingsByKey : localSettings;
};

export const getPriceByPercent = (price: number = 0, percent: number) => +(price + (price / 100) * percent).toFixed(2);
